import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material';



import { Error404Component } from 'app/core/pages/errors/404/error-404.component';
import { FlexLayoutModule } from '@angular/flex-layout';

const routes = [
    {
        path     : 'errors/error-404',
        component: Error404Component
    }
];

@NgModule({
    declarations: [
        Error404Component
    ],
    imports     : [
        RouterModule.forChild(routes),

        MatIconModule,
        FlexLayoutModule
    ]
})
export class Error404Module
{
}
